import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../../services/services.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import swal from 'sweetalert2';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-project-order',
  templateUrl: './project-order.component.html',
  styleUrls: ['./project-order.component.css']
})
export class ProjectOrderComponent implements OnInit {
  fields: any = [];
  listData: any = [];

  public loading = false;
  isLoader: boolean = false;
  public show: boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  spinLoader = {
    filter: false,
    delete: []
  };
  addProjectOrderForm: FormGroup;

  isListData = true;
  isOnePage = false;
  route: string;
  apiUrl = environment.apiUrl;
  tempProjectId: any;

  constructor(private _services: ServicesService, private router: Router) {}

  ngOnInit() {
    this._services.checkToken('status');

    this.getPageRequest();
    const token = localStorage.getItem('userToken');
    this.fields = [
      {
        field: 'project_name',
        title: 'Project Name',
        width: '25%',
        code: false,
        sort: true
      },
      // {
      //   field: 'project_manager_name',
      //   title: 'Client Name',
      //   width: '20%',
      //   code: false,
      //   sort: true
      // },
      {
        field: 'project_commencement_date',
        title: 'Project Commencement Date',
        width: '20%',
        code: false,
        sort: true
      },
      {
        field: 'address',
        title: 'Project Address ',
        width: '20%',
        code: false,
        sort: true
      }
    ];

    this.addProjectOrderForm = new FormGroup({
      project_name: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      project_commencement_date: new FormControl('', [Validators.required])
    });
  }

  resetSearchField() {
    this.spinLoader['filter'] = true;
    this.searchFields = [''];
    this.getPageRequest();
  }

  getSearchRequest() {
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }

  status: any;

  // deleteProject(id){
  //   this.status = confirm("Are You Sure");
  //   if(this.status){
  //     this.route = 'delete-project';
  //     let token = this._services.getToken();
  //     var data = {
  //       'id':id,
  //       page  : this.currentPage,
  //       search: {
  //         'project_name' : this.searchFields['project_name'],
  //       },
  //       sort  : this.sortingData
  //     };
  //     this._services.postRequest(data,this.route,token).subscribe((data: any) => {
  //       swal({
  //         title: 'Deleted.',
  //         text: data.message,
  //         type: 'success',
  //         showCancelButton: false,
  //         confirmButtonColor: 'rgb(17, 205, 239)',
  //         cancelButtonColor: 'rgb(245, 54, 92)',
  //         confirmButtonText: 'Yes'
  //       }).then(() => {
  //         this.listData = data.result;
  //         this.paginate = data.paginate;
  //         this.getPages(this.paginate.last_page);
  //       })
  //     });
  //   }
  // }

  sortType: string = '';
  sortField: string = '';
  oldField: string;
  sortingData = {
    field: '',
    type: ''
  };

  sortBy(field, event) {
    this.spinLoader['filter'] = true;
    this.oldField = this.oldField != field ? this.oldField : field;

    if (typeof this.oldField !== 'undefined') {
      ////console.log(document.getElementById('fa-'+this.oldField));
      document.getElementById('fa-' + this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-' + this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-' + this.oldField).classList.add('fa-sort');
    }

    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = this.sortType == 'desc' ? 'asc' : 'desc';

    switch (this.sortType) {
      case 'desc':
        {
          event.target.classList.remove('fa-sort-up');
          event.target.classList.add('fa-sort-down');
          this.oldField = field;
        }
        break;
      case 'asc':
        {
          event.target.classList.remove('fa-sort-down');
          event.target.classList.add('fa-sort-up');
          this.oldField = field;
        }
        break;
      default: {
        event.target.classList.add('fa-sort');
      }
    }

    this.sortingData = {
      field: this.sortField,
      type: this.sortType
    };

    this.getPageRequest();
  }
  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate = {
    last_page: 1,
    total: 0,
  };
  searchFields = [];
  pages: any;
  //   listData = [];
  editData: Object = {};

  previousPage() {
    if (this.currentPage == 1) {
      return;
    }

    this.currentPage = this.currentPage - 1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  nextPage() {
    if (this.paginate.last_page - 1 < this.currentPage) {
      return;
    }

    this.currentPage++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage() {
    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n) {
    if (n > 1) {
      this.isOnePage = true;
    } else {
      this.isOnePage = false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/
  routeData: string;
  totalData: any;
  getPageRequest() {
    let data;
    this.routeData = 'get-project-order-web';
    switch (this.routeData) {
      case 'get-project-order-web': {
        data = {
          page: this.currentPage,
          search: {
            project_name: this.searchFields['project_name']
          },
          sort: this.sortingData
        };
        break;
      }
    }

    this.loading = true;
    const token = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      result = result.result;
      if (this._services.checkToken(result.result.status)) {
        this.spinLoader['filter'] = false;
        this.isListData = false;

        this.listData = [];
        this.listData = result.result;
        // //console.log(this.listData);
        this.totalData = result.paginate.total;
        this.currentPage = result.paginate.current_page;
        this.paginate = result.paginate;

        if (result.paginate.current_page > result.paginate.last_page) {
          this.currentPage = result.paginate.last_page;
        }
        //console.log(this.paginate.last_page);

        this.getPages(this.paginate.last_page);

        for (let key in this.spinLoader) {
          if (key == 'delete') {
            this.spinLoader[key] = [];
          } else {
            this.spinLoader[key] = false;
          }
        }
      }
    });

    return true;
  }

  projectData = {
    client_name: '',
    project_name: '',
    project_commencement_date: '',
    address: ''
  };

  Show(userData) {
    this.projectData = userData;
    //console.log(this.projectData);
    this.show = true;
    this.tempProjectId = userData.id;
    //console.log(this.tempProjectId);
  }
  back() {
    this.show = false;
  }

  isFormSubmitted = false;
  showloader = false;
  routePath;

  // convenience getter for easy access to form fields
  get f() {
    return this.addProjectOrderForm.controls;
  }

  updateOrderProject(id = null) {
    this.addProjectOrderForm.value['id'] = id ? id : this.tempProjectId;
    //console.log(this.addProjectOrderForm);
    this.isFormSubmitted = true;
    this.showloader = true;

    this.routePath = 'create-project-order'; // it also update project order
    this._services.requestCreator(this.addProjectOrderForm.value, this.routePath, this._services.getToken()).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        this.showloader = false;
        this.isFormSubmitted = false;
        swal({
          title: 'Project',
          text: 'Project Updated Successfully',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        }).then(() => {
          this.getPageRequest();
        });
      } else {
        this.showloader = false;
        this.isFormSubmitted = false;
      }
    });
  }

  deleteProject(id) {
    this.addProjectOrderForm.value['is_active'] = 0;
    //console.log(this.addProjectOrderForm);
    this.updateOrderProject(id);
  }
}
